module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu5mxKOzY.8bb64952.woff2";